/** One press of the size stepper, or one arrow key in the size field, in pt. */
export const EDITOR_SIZE_STEP_PT = 0.5

/** How long a stepper button is held before it starts repeating. */
export const EDITOR_SIZE_STEP_HOLD_MS = 400

/** The interval between the steps a held stepper button gives. */
export const EDITOR_SIZE_STEP_REPEAT_MS = 60
